import { HorizontalTabLinkProps } from '../../../components'
import * as ROUTES from '../../../routes/constants/routeConstants'
import { AssignmentInfo } from '../tabs/assignments'
import { BaseDetails } from '../tabs/base-details'
import { EmploymentInfo } from '../tabs/employment'
import { Membership } from '../tabs/membership'

export const OWNINFO_TAB_PROPS: HorizontalTabLinkProps[] = [
  {
    exact: false,
    infoBoxProps: {
      translationId: 'pages.ownInfoPage.baseDetails.informationText'
    },
    key: 'base-details',
    tab: ROUTES.OWNINFO_TAB_BASEDETAILS,
    to: ROUTES.ROUTE_OWNINFO_BASEDETAILS,
    translationId: 'pages.ownInfoPage.baseDetails.label',
    TabElement: BaseDetails
  },
  {
    exact: false,
    infoBoxProps: {
      translationId: 'pages.ownInfoPage.membership.informationText'
    },
    key: 'membership',
    tab: ROUTES.OWNINFO_TAB_MEMBERSHIP,
    to: ROUTES.ROUTE_OWNINFO_MEMBERSHIP,
    translationId: 'pages.ownInfoPage.membership.label',
    TabElement: Membership
  },
  {
    exact: false,
    infoBoxProps: {
      styledEndPartProps: {
        translationId:
          'pages.ownInfoPage.employment.informationTextStyledEndPart',
        typographyProps: { fontWeight: 600 }
      },
      translationId: 'pages.ownInfoPage.employment.informationText'
    },
    key: 'employment',
    tab: ROUTES.OWNINFO_TAB_EMPLOYMENT,
    to: ROUTES.ROUTE_OWNINFO_EMPLOYMENT,
    translationId: 'pages.ownInfoPage.employment.label',
    TabElement: EmploymentInfo
  },
  {
    exact: false,
    infoBoxProps: {
      translationId: 'pages.ownInfoPage.assignments.informationText'
    },
    key: 'assignments',
    tab: ROUTES.OWNINFO_TAB_ASSIGNMENTS,
    to: ROUTES.ROUTE_OWNINFO_ASSIGNMENTS,
    translationId: 'pages.ownInfoPage.assignments.label',
    TabElement: AssignmentInfo
  }
]
